import { SHOW_LOVE_OPTIONS } from '../SHOW_LOVE_OPTIONS';
import { ShowLoveOptionIdType } from '../types';

export const getShowLoveTitleById = (
  id: ShowLoveOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return SHOW_LOVE_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: ShowLoveOptionIdType = 'physical_touch';

export const getShowLoveIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): ShowLoveOptionIdType | null => {
  const id = SHOW_LOVE_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
